import alt from 'alt'
import { createStore, datasource } from 'alt-utils/lib/decorators'
import { NotFoundCheckDetailActions } from 'actions'

@createStore(alt)
export default class NotFoundCheckDetailStore {
  constructor() {
    this.bindActions(NotFoundCheckDetailActions)
  }

  static displayName = 'NotFoundCheckDetailStore'
}



// WEBPACK FOOTER //
// ./app/stores/NotFoundCheckDetailStore.js